import { render, staticRenderFns } from "./_svg-filters.vue?vue&type=template&id=0d1c0856&scoped=true&"
import script from "./_svg-filters.vue?vue&type=script&lang=js&"
export * from "./_svg-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1c0856",
  null
  
)

export default component.exports